import { render, staticRenderFns } from "./ProposalListTable.vue?vue&type=template&id=0d1cc32d"
import script from "./ProposalListTable.vue?vue&type=script&lang=js"
export * from "./ProposalListTable.vue?vue&type=script&lang=js"
import style0 from "./ProposalListTable.vue?vue&type=style&index=0&id=0d1cc32d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProposalListTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports